module.exports = __webpack_public_path__ + "img/xxx-step-one-img.c3353f7.svg";